var map = {
	"./Article Bernard Forum des tortues.pdf": 8717,
	"./Article Journal de Vanves.pdf": 122,
	"./Article LIGEIA.pdf": 5397,
	"./Article Les Saisons de la danse.pdf": 7589,
	"./Communiqué de Patrick Delgado.pdf": 5896,
	"./Corps de tortues.pdf": 8675,
	"./La tortue un corps à peindre.pdf": 7668,
	"./Pierre BACCI FFEPT.pdf": 8811,
	"./Soulahfate Besma.pdf": 1735,
	"./Vanves 2001.pdf": 8398,
	"./Version Chinoise la tortue un corps à peindre.pdf": 1898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6716;